export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--9.f3eef7f9.png";